/**
 * `poStatus` → operator-facing label + StatusPill tone.
 *
 * The wire enum has seven values; V1 composer/detail surfaces the full
 * set so partially_received / received rows (set downstream by the GRN
 * flow once it lands) still render with the right chrome.
 *
 * @see packages/api-contract/src/procedures/purchase-orders.ts (poStatus)
 */
import type { StatusTone } from "@flint/ui";

export type PoStatus =
  | "draft"
  | "sent"
  | "confirmed"
  | "partially_received"
  | "received"
  | "closed"
  | "cancelled";

const META: Record<PoStatus, { label: string; tone: StatusTone }> = {
  draft: { label: "Draft", tone: "muted" },
  sent: { label: "Sent", tone: "sky" },
  confirmed: { label: "Confirmed", tone: "sky" },
  partially_received: { label: "Partially received", tone: "warn" },
  received: { label: "Received", tone: "ok" },
  closed: { label: "Closed", tone: "ok" },
  cancelled: { label: "Cancelled", tone: "muted" },
};

export function poStatusLabel(status: PoStatus): string {
  return META[status]?.label ?? status;
}

export function poStatusTone(status: PoStatus): StatusTone {
  return META[status]?.tone ?? "muted";
}
